/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

const actions = {
	// // ////////////////////////////////////////////
	// // SIDEBAR & UI UX
	// // ////////////////////////////////////////////
	// updateSidebarWidth({ commit }, width) {
	// 	commit('updateSideBarWidth', width);
	// },
	// updateI18nLocale({ commit }, locale) {
	// 	commit('updateI18nLocale', locale);
	// },
	// updateTheme({ commit }, val) {
	// 	commit('updateTheme', val);
	// },

	// //  The Navbar
	// arrangeStarredPagesLimited({ commit }, list) {
	// 	commit('arrangeStarredPagesLimitted', list);
	// },
	// arrangeStarredPagesMore({ commit }, list) {
	// 	commit('arrangeStarredPagesMore', list);
	// }
};

export default actions;
